export default __webpack_public_path__ + "images/BT.8b8b84c.png";